import { createContext, useContext, useEffect, useState } from 'react';
import { getClipBroadcastId } from '@goldcast/player-config/src/utils/clipUtils';
import { selectSpeakerDetails } from '@goldcast/player-config/src/selectors/contentMetadataStoreSelectors';
import { getSegmentSpeaker, getSegmentWordsAndStartSegment } from './utils';
import { SpeakerSegmentContextType } from './SpeakerSegmentContextTypes';
import { useClipsContext } from '../ClipsContext/ClipsContext';
import { updateSharedAPIWithId } from '@/stores/sharedAPI/sharedAPI';
import { useContentMetadataStore } from '@/stores/contentMetaDataStore/contentMetaDataStore';

export const SpeakerSegmentContext = createContext<SpeakerSegmentContextType | undefined>(undefined);

export function SpeakerSegmentContextProvider({ children }) {
  const [speakerSegmentContextData, setSpeakerSegmentContextData] = useState<SpeakerSegmentContextType>();
  const { clipId, clipData } = useClipsContext();
  const broadcastId = getClipBroadcastId(clipData) ?? '';
  const speakersWithDetails = useContentMetadataStore(selectSpeakerDetails(broadcastId));

  useEffect(() => {
    if (clipData?.asset_metadata?.captions) {
      const captions = clipData?.asset_metadata?.captions;
      //should calculate by backend
      const { startSegment, segmentWords } = getSegmentWordsAndStartSegment(captions);
      const segmentSpeaker = getSegmentSpeaker(segmentWords, speakersWithDetails);

      const srtCaptions = captions.reduce((acc, caption) => {
        if (!caption.hidden) {
          acc[caption.srt_index] = [...(acc[caption.srt_index] || []), caption];
        }
        return acc;
      }, {});

      setSpeakerSegmentContextData({
        segmentWords,
        startSegment,
        segmentSpeaker,
        captions,
        srtCaptions
      });
    }
  }, [clipData.asset_metadata?.captions, speakersWithDetails]);

  useEffect(() => {
    updateSharedAPIWithId(clipId, { speakerSegmentStore: speakerSegmentContextData });
  }, [clipId, speakerSegmentContextData]);

  return <SpeakerSegmentContext.Provider value={speakerSegmentContextData}>{children}</SpeakerSegmentContext.Provider>;
}

export function useSpeakerSegmentContext() {
  return useContext(SpeakerSegmentContext);
}
